var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClubMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Club"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 89",
    d: "M9.52321 5.52327C9.7882 6.94256 10.0654 7.35037 10.7344 7.57337C11.2075 7.73107 12.157 7.81738 12.9423 7.88877C14.677 8.04647 14.8851 8.04651 15.8313 8.04651C15.6736 7.31056 15.3582 5.80713 15.3582 5.68097C15.3582 5.52327 14.8851 4.10395 15.989 3.94625C17.0929 3.78854 17.566 4.73476 17.7237 5.20786C17.8814 5.68097 19.0926 8.99269 18.4618 9.6235C17.7753 10.3101 16.4621 10.412 11.731 10.2543C6.99997 10.0966 6.99997 6.16969 7 5.36557V5.36533C7.00003 4.57671 7.00009 3 8.26162 3C9.3655 3 9.34954 4.59313 9.52321 5.52327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 88",
    d: "M15.7734 19.7506C14.3628 19.7492 13.1871 17.4884 13 16.4538L14.4999 13.5001L16.0442 16.8169L17.5268 15.2668C17.9362 14.8722 18.9664 14.3654 19.5723 15.0571C20.098 15.6574 19.9519 16.2706 19.8248 16.4539C19.062 17.5533 17.1839 19.7519 15.7734 19.7506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    x: 9.47266,
    y: 8.04639,
    width: 5.36188,
    height: 9.14674,
    rx: 2.68094,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 270",
    cx: 12.6268,
    cy: 5.52329,
    r: 1.89243,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80",
    d: "M9.62827 14.4271C9.80687 13.639 10.5906 13.1448 11.3788 13.3234C12.1847 13.506 12.6797 14.3193 12.4716 15.119L11.6243 18.375C11.5685 18.5894 11.5309 18.808 11.5117 19.0287L11.2638 21.8858C11.1877 22.7624 10.3553 23.3703 9.49705 23.1758C8.77135 23.0113 8.28756 22.3247 8.3769 21.586L8.80135 18.0764L9.62827 14.4271Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubMini);
export default __webpack_public_path__ + "static/media/club-mini.d674568eb77de09784720d4da316d5ea.svg";
export { ForwardRef as ReactComponent };